// #DESIGN_2023
export const textStyles = {
  h1: {
    fontSize: ['1.8125rem', null, '3.45rem'], // [29px, null, 55px]
    fontWeight: 'black',
    letterSpacing: '0.5px',
    lineHeight: '1.2',
  },
  h2: {
    fontSize: ['1.625rem', null, '2.75rem'], // [26px, null, 44px]
    fontWeight: 'black',
    letterSpacing: '0.5px',
    lineHeight: '1.2',
  },
  h3: {
    fontSize: ['1.4375rem', null, '2.1875rem'], // [23px, null ,35px]
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: '1.2',
  },
  h4: {
    fontSize: ['1.25rem', null, '1.75rem'], // [20px, null, 28px]
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: '1.2',
  },
  h5: {
    fontSize: ['1.125rem', null, '1.375rem'], // [18px, null, 22px]
    fontWeight: 'semibold',
  },
  h6: {
    fontSize: ['1rem', null, '1.125rem'], // [16px, null, 18px],
    fontWeight: 'semibold',
  },
}
